module.exports = __webpack_public_path__ + "img/image-icon.fbe51bb9.svg";